import { checkIsAgent, checkIsPerformer, checkIsCD } from "shared-auth";
import { HeapCustomEvent, HeapService } from "shared-services";

const PATH_NAME = window.location.pathname;
const VIDEO_ENDPOINT = "/profile/media/video";
const AUDIO_ENDPOINT = "/profile/media/audio";

const profileUpdate = () => {
  HeapService.track(HeapCustomEvent.ProfileUpdate);
};

const audioClipsPerformerUpdate = () => {
  HeapService.track(HeapCustomEvent.AudioClipsPerformer);
};

const audioClipsAgentUpdate = () => {
  HeapService.track(HeapCustomEvent.AudioClipsAgent);
};

const videoPerformerUpdate = () => {
  HeapService.track(HeapCustomEvent.VideosPerformer);
};

const videoAgentUpdate = () => {
  HeapService.track(HeapCustomEvent.VideosAgent);
};

const cdAudioVideoPlayed = () => {
  HeapService.track(HeapCustomEvent.CDAudioVideoPlayed);
};

const agentAudioVideoPlayed = () => {
  HeapService.track(HeapCustomEvent.AgentAudioVideoPlayed);
};

const profileEdited = () => {
  HeapService.track(HeapCustomEvent.ProfileIsEdited);
};

const checkIsPerformerWithAudioEndpoint = () =>
  checkIsPerformer() && PATH_NAME === AUDIO_ENDPOINT;

const checkIsAgentWithAudioEndpoint = () =>
  checkIsAgent() && PATH_NAME === AUDIO_ENDPOINT;

const checkIsPerformerWithVideoEndpoint = () =>
  checkIsPerformer() && PATH_NAME === VIDEO_ENDPOINT;

const checkIsAgentWithVideoEndpoint = () =>
  checkIsAgent() && PATH_NAME === VIDEO_ENDPOINT;

export const heapTrackingForChangeMainPhotoFlow = () => {
  if (checkIsPerformer()) {
    HeapService.track(HeapCustomEvent.HeadShotPerformer);
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.HeadShotAgent);
  }

  profileUpdate();
};

export const heapTrackingForControlsContainer = () => {
  if (checkIsPerformerWithAudioEndpoint()) {
    audioClipsPerformerUpdate();
  }

  if (checkIsAgentWithAudioEndpoint()) {
    audioClipsAgentUpdate();
  }

  if (checkIsPerformerWithVideoEndpoint()) {
    videoPerformerUpdate();
  }

  if (checkIsAgentWithVideoEndpoint()) {
    videoAgentUpdate();
  }
};

export const heapTrackingForAddNewAudiPage = () => {
  if (checkIsPerformer()) {
    audioClipsPerformerUpdate();
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.AudioClipsAgent);
  }

  profileUpdate();
};

export const heapTrackingForReorderableList = () => {
  heapTrackingForControlsContainer();
};

export const heapTrackingForAddNewVideoPage = () => {
  if (checkIsPerformer()) {
    videoPerformerUpdate();
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.VideosAgent);
  }

  profileUpdate();
};

export const heapTrackingForBasicInfoPage = () => {
  if (checkIsPerformer()) {
    HeapService.track(HeapCustomEvent.DetailsPerformer);
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.DetailsAgent);
  }

  profileUpdate();
};

export const heapTrackingForSkillsPageSkillUpdate = () => {
  if (checkIsPerformer()) {
    HeapService.track(HeapCustomEvent.SkillsPerformer);
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.SkillsAgent);
  }
};

export const heapTrackingForAboutMePage = () => {
  if (checkIsPerformer()) {
    HeapService.track(HeapCustomEvent.AboutMePerformer);
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.AboutMeAgent);
  }

  profileUpdate();
};

export const heapTrackingForEditCreditPage = () => {
  if (checkIsPerformer()) {
    HeapService.track(HeapCustomEvent.CreditsPerformer);
  }

  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.CreditsAgent);
  }

  profileUpdate();
};

export const heapTrackingForAddAgencyPage = () => {
  profileUpdate();
};

export const heapTrackingForAgenciesPage = () => {
  profileUpdate();
};

export const heapTrackingForSkillsPageProfileUpdate = () => {
  profileUpdate();
};

export const heapTrackingForTrainingPage = () => {
  profileUpdate();
};

export const heapTrackingForMediaSection = () => {
  if (checkIsCD()) {
    cdAudioVideoPlayed();
  }

  if (checkIsAgent()) {
    agentAudioVideoPlayed();
  }
};

export const heapTrackingForAudioClips = () => {
  if (checkIsAgent()) {
    agentAudioVideoPlayed();
  }

  if (checkIsCD()) {
    cdAudioVideoPlayed();
  }
};

export const heapTrackingForShowreels = () => {
  heapTrackingForAudioClips();
};

export const heapTrackingForMainPageEmailProfile = () => {
  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.AgentEmailProfile);
  }

  if (checkIsCD()) {
    HeapService.track(HeapCustomEvent.CDEmailProfile);
  }
};

export const heapTrackingForMainPagePrintProfile = () => {
  if (checkIsAgent()) {
    HeapService.track(HeapCustomEvent.AgentPrintProfile);
  }

  if (checkIsCD()) {
    HeapService.track(HeapCustomEvent.CDPrintProfile);
  }
};

export const heapTrackingForAgenciesSection = () => {
  if (checkIsPerformer() || checkIsAgent()) {
    profileEdited();
  }
};

export const heapTrackingForBasicInfoSection = () => {
  heapTrackingForAgenciesSection();
};

export const heapTrackingForEditPanel = () => {
  heapTrackingForAgenciesSection();
};

export const heapTrackingForRowGallery = () => {
  heapTrackingForAgenciesSection();
};

export const heapTrackingForReorderableMediaAssets = () => {
  if (checkIsPerformerWithAudioEndpoint()) {
    audioClipsPerformerUpdate();
  }
};

export const heapTrackingForShowreelsSortCompleted = () => {
  if (checkIsPerformerWithVideoEndpoint()) {
    videoPerformerUpdate();
  }
};
